'use client';

import axios from 'axios';
import { apiServer, mapLandDataUrl, mapLandPriceDataUrl } from '../constants/map';
import { useCallback, useEffect, useState } from "react";
import { useMapContext } from '../contexts/map-context';
import { GET_ALL_LAND_INFO } from '../apollo/queries';
import { graphEndpoint } from '../helper/subgraphs'

const useLandMap = () => {
    const [landData, setLandData] = useState([]);
    const [landPriceData, setLandPriceData] = useState({}) as any;
    const [isLandDataLoaded, setIsLandDataLoaded] = useState(false);

    const { dispatch } = useMapContext();

    const setSearchOptions = (newOptions: any) => {
        dispatch({ type: 'UPDATE_SEARCH_OPTIONS', payload: { newOptions } });
    };

    const fetchAllLandInfo = useCallback(async () => {
        try {
            const GET_LANDS_ENDPOINT = graphEndpoint(true);
            const response = await axios.post(GET_LANDS_ENDPOINT, {
                query: GET_ALL_LAND_INFO
            });
            const GET_ALL_LANDS_DATA = response.data;
            if (!GET_ALL_LANDS_DATA.data.landInfos.length) throw new Error(`Failed to fetch all land data`);

            const result_data = GET_ALL_LANDS_DATA.data.landInfos.filter((item: any) => item.tierName !== 'locked');
            const objectData = result_data.reduce((acc: any, item: any) => {
                acc[item.id] = { ...item };
                return acc;
            }, {});
            setLandData(result_data);
            setLandPriceData(objectData);
            setIsLandDataLoaded(true);
        } catch (error) {
            console.log('Error fetching all land data:', error);
        }
    }, []);

    useEffect(() => {
        fetchAllLandInfo();
        const refreshInterval = setInterval(fetchAllLandInfo, 40000);
        return () => clearInterval(refreshInterval);
    }, [fetchAllLandInfo]);



    const updatePriceData = (newData: any) => {
        setLandPriceData((prev: any) => ({ ...prev, ...newData }));
    };

    return { landData, landPriceData, updatePriceData, isLandDataLoaded, fetchAllLandInfo };
};

export default useLandMap;